import {Component, Input, isDevMode} from '@angular/core';
import {ICheckboxRadioChoice} from "@shared/models/interfaces/check-radio-choice.interface";
import {FormField} from "@shared/components/form/models/beans/form-field.abstract";

let nextInstanceId = 0;

@Component({
  selector: 'radiofields[form]',
  templateUrl: './radiofields.component.html',
  styleUrls: ['./radiofields.component.scss']
})
export class RadiofieldsComponent extends FormField {

  isDevMode = isDevMode;
  @Input() choices: ICheckboxRadioChoice[];
  @Input() block = false;

  // Same field can be rendered twice (InfoPath layout): ids must be unique per instance, while [name] must stay
  // shared — it is the RadioControlValueAccessor group key that keeps the instances in sync (not a DOM attribute)
  readonly instanceId = nextInstanceId++;

  clear() {
    this.form.get(this.fieldName).setValue('');
  }

}
